import { Chip as MuiChip, Box, ChipProps as MuiChipProps } from '@mui/material';
import { Link } from 'react-router-dom';

interface ChipData {
  id: number | string;
  label: string;
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  variant?: 'filled' | 'outlined';
  to?: string; // Optional link destination
}

interface ChipListProps {
  items: ChipData[];
  loading?: boolean;
  emptyText?: string;
  emptyColor?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  direction?: 'row' | 'column';
  size?: 'small' | 'medium';
}

export const ChipList = ({
  items,
  loading = false,
  emptyText = 'No items',
  emptyColor = 'default',
  direction = 'row',
  size = 'small',
}: ChipListProps) => {
  if (loading) return <>Loading...</>;

  if (!items || items.length === 0) {
    return <MuiChip label={emptyText} size={size} color={emptyColor} variant="outlined" />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: direction === 'row' ? { xs: 'column', sm: 'row' } : 'column',
        gap: { xs: 0.5, sm: 1 },
        flexWrap: 'wrap',
      }}
    >
      {items.map((item) => {
        const chipProps: MuiChipProps = {
          label: item.label,
          size,
          color: item.color || 'secondary',
          variant: item.variant || 'outlined',
        };

        if (item.to) {
          return (
            <Link
              key={item.id}
              to={item.to}
              style={{ textDecoration: 'none' }}
              onClick={(e) => e.stopPropagation()}
            >
              <MuiChip {...chipProps} clickable />
            </Link>
          );
        }

        return <MuiChip key={item.id} {...chipProps} />;
      })}
    </Box>
  );
};

// Backward compatibility alias
export { ChipList as GroupChips };
